import { Toast } from 'antd-mobile';
import { pageInstance, pageMethod  } from '@utils/page';
import { appMethod as app, appInstance } from '@utils/app';
/**
 * 点击事件集合
 */
const handler = {
  /**
   * 详情：商品详情
   */
  'goods-trade': ({customFeature, franchisee}) => {
    let type = customFeature['goods-type'] || customFeature['goods_type'];
    let id = customFeature['goods-id'] || customFeature['goods_id'];
    if (!id) {
      return;
    }
    let router = '';
    if (type == 3) {
      router = 'toStoreDetail';
    } else if (type == 10) {
      if (customFeature.unit == 3) {
        router = 'hotel';
      } else {
        router = 'newAppointmentDetail';
      }
    } else {
      router = 'goodsDetail';
    }
    app.turnToPage(router, {
      detail: id,
      franchisee: franchisee || app.getPageFranchiseeId() || '',
    });
  },
  /**
   * 营销：秒杀
   */
  'to-seckill': ({customFeature, franchisee}) => {
    let id = customFeature['seckill-id'] || customFeature['seckill_id'];
    if (!id) {
      return;
    }
    let activityId = customFeature['seckill-activity-id'] || 0;
    app.turnToPage('seckillDetail', {
      detail: id,
      franchisee: franchisee || app.getPageFranchiseeId() || '',
      sec_act_id: activityId || 0,
      sec_t_id: customFeature['seckill-activity-time-id'] || 0,
      secType: activityId != 0 ? 1 : 0,
    });
  },
  /**
   * 页面
   */
  'inner-link': ({customFeature, franchisee}) => {
    let router = customFeature['inner-page-link'] || customFeature['page-link'] || customFeature['inner_page_link'];
    let pageInstance = app.getAppCurrentPage();
    if (router === 'prePage') {
      app.turnBack();
    } else {
      // 当前参数尚未有作用
      let isRedirect = customFeature.is_redirect == 1;
      let pageRouter = pageInstance.state.router;
      if (pageRouter == app.globalData.homepageRouter || app.getTabPagePathArr().indexOf(router) !== -1) {
        isRedirect = false;
      }
      app.turnToPage(router, {
        franchisee: franchisee || app.getPageFranchiseeId() || ''
      }, isRedirect);
    }
  },
  /**
   * 营销：拼团
   */
  'group-buy': ({customFeature, franchisee}) => {
    let goodsId = customFeature['goods-id'] || customFeature['goods_id'];
    if (!goodsId) {
      return;
    }
    app.turnToPage('gpgoodsDetail', {
      goods_id: goodsId,
      activity_id: customFeature['active-id'] || customFeature['active_id'],
      franchisee: franchisee || app.getPageFranchiseeId() || '',
    });
  },
  /**
   * 营销：预售
   */
  'presell': ({customFeature, franchisee}) => {
    let goods_id = customFeature['goods-id'] || customFeature['goods_id'];
    franchisee = franchisee || app.getPageFranchiseeId() || '';
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (goods_id) {
      app.turnToPage('presellDetail?detail=' + goods_id + chainParam);
    }
  },
  /**
   * 功能：拨打电话
   */
  'call': ({customFeature, realValue}) => {
    if (customFeature && customFeature['phoneNumberSource'] === 'dynamic') {
      let phoneNum = realValue ? realValue : '';
      if (!phoneNum) {
        return;
      }
      app.makePhoneCall(phoneNum);
      return;
    }
    let phoneNum = customFeature['phone-num'] || customFeature['phone_num'];
    app.makePhoneCall(phoneNum);
  },
  /**
   * 详情：优惠券详情
   */
  'get-coupon': ({customFeature, franchisee}) => {
    let couponId = customFeature['coupon-id'] || customFeature['coupon_id'];
    if (!couponId) {
      return;
    }
    app.turnToPage('couponDetail', {
      detail: couponId,
      recv_type: customFeature['recv_type'],
      franchisee: franchisee || app.getPageFranchiseeId() || ''
    })
  },
  /**
   * 详情：社区详情
   */
  'community': ({customFeature, franchisee}) => {
    app.turnToPage('communityPage', {
      detail: customFeature['community-id'] || customFeature['community_id'],
      franchisee: franchisee || app.getPageFranchiseeId() || ''
    })
  },
  /**
   * 功能：多商家入驻
   */
  'franchisee-enter': () => {
    app.turnToPage('franchiseeEnter');
  },
  /**
   * 多商家：合作联系
   */
  'franchisee-cooperation': () => {
    app.turnToPage('franchiseeCooperation');
  },
  /**
   * 详情：商家详情
   */
  'to-franchisee': ({customFeature}) => {
    let franchisee_id = customFeature['franchisee-id'] || customFeature['franchisee_id'];
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: {
        sub_shop_app_id: franchisee_id
      },
      success: function (res) {
        if (res.status === 0 && Array.isArray(res.data) && res.data[0]) {
          let shopInfo = res.data[0];
          let subAppBar = shopInfo.sub_app_bar;
          let appid = franchisee_id;
          let audit = shopInfo.is_audit;
          let mode = shopInfo.mode_id;
          let id = shopInfo.id;
          let newmode = subAppBar.mode_id || '';
          let pageLink = subAppBar['homepage-router'] || '';
          let param = {};

          param.detail = appid;
          if (audit == 2) {
            param.shop_id = id;
          }
          if (pageLink) {
            mode = newmode;
            switch (pageLink.trim()) {
              case 'franchiseeWaimai':
                app.goToFranchisee(1, param);
                return;
              case 'franchiseeTostore':
                app.goToFranchisee(3, param);
                return;
              case 'franchiseeDetail4':
                app.goToFranchisee(2, param);
                return;
              case 'franchiseeDetail':
                app.goToFranchisee(0, param);
                return;
              default:
                break;
            }
            app.turnToPage(pageLink, {
              franchisee: franchisee_id,
              fmode: mode
            });
            return;
          }
          app.goToFranchisee(mode, param);
        } else {
          app.showModal({
            content: '获取子店信息失败'
          });
        }
      },
      error: function () {
        app.showModal({
          content: '获取子店信息失败'
        });
      }
    });
  },
  /**
   * 开启推广
   */
  'to-promotion': () => {
    app._isOpenPromotion();
  },
  /**
   * 营销：优惠券列表
   */
  'coupon-receive-list': () => {
    app.turnToPage('couponReceiveListPage');
  },
  /**
   * 营销：储值
   */
  'recharge': () => {
    app.turnToPage('recharge');
  },
  /**
   * 营销：大转盘
   */
  'lucky-wheel': ({franchisee}) => {
    app.turnToPage('luckyWheelDetail', {
      franchisee: franchisee || app.getPageFranchiseeId() || ''
    });
  },
  /**
   * 营销：砸金蛋
   */
  'golden-eggs': ({franchisee}) => {
    app.turnToPage('goldenEggs', {
      franchisee: franchisee || app.getPageFranchiseeId() || ''
    });
  },
  /**
   * 营销：刮刮乐
   */
  'scratch-card': ({franchisee}) => {
    app.turnToPage('scratch', {
      franchisee: franchisee || app.getPageFranchiseeId() || ''
    });
  },
  /**
   * 营销：集集乐
   */
  'collect-stars': ({franchisee}) => {
    app.turnToPage('collectStars', {
      franchisee: franchisee || app.getPageFranchiseeId() || ''
    });
  },
  /**
   * 详情：视频详情
   */
  'video': ({customFeature, franchisee}) => {
    let video_id = customFeature['video-id'];
    app.turnToPage('videoDetail', {
      detail: video_id,
      franchisee: franchisee || app.getPageFranchiseeId() || ''
    });
  },
  /**
   * 详情：视频详情
   */
  'video-detail': ({customFeature, franchisee}) => {
    let video_id = customFeature['video_id'] ||  customFeature['video-id'];
    app.turnToPage('videoDetail', {
      detail: video_id,
      franchisee: franchisee || app.getPageFranchiseeId() || ''
    });
  },
  /**
   * 详情：视频播放
   */
  'video-play': ({customFeature}) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = customFeature.compindex;
    let video_id = customFeature['video-id'];
    app.sendRequest({
      url: '/index.php?r=AppVideo/GetVideoLibURL',
      method: 'get',
      data: { id: video_id },
      success: function (res) {
        let newdata = {}
        newdata['eles[' + compindex + '].videoUrl'] = res.data;
        // TOOO 未处理
        newdata['eles[' + compindex + '].carouselVideoTop'] = pageInstance.data.page_hasNavBar ? app.globalData.topNavBarHeight : 0;
        pageInstance.setData(newdata);
      }
    })
  },
  /**
   * 营销：当面付
   */
  'transfer': ({franchisee}) => {
    app.turnToPage('transferPage', {
      franchisee: franchisee || app.getPageFranchiseeId() || ''
    });
  },
  /**
   * 功能：跳转小程序
   */
  'turn-to-xcx': ({customFeature}) => {
    Toast.info(<div><div>暂不支持</div><div>【跳转小程序】功能</div></div>);
    // app.navigateToXcx({
    //   appId: customFeature['xcx-appid'] || customFeature['xcx_appid'],
    //   path: customFeature['xcx-page-url'] || customFeature['xcx_page_url'] || ''
    // });
  },
  /**
   * 微信小程序: 联系客服
   */
  'contact': () => {
    Toast.info(<div><div>暂不支持</div><div>【联系客服】功能</div></div>);
  },
  /**
   * 功能：Wifi
   * TODO 未确认实现方案
   */
  'wifi': ({customFeature, franchisee}) => {
    Toast.info('当前不支持wifi功能');
  },
  /**
   * 功能：跳转插件
   * TODO 未确认实现方案
   */
  'plugin-link': ({customFeature, franchisee}) => {
    Toast.info('当前不支持跳转插件');
  },
  /**
   * 详情：话题详情
   */
  'topic': ({customFeature, franchisee}) => {
    let topicId = customFeature['topic-id'] || customFeature['topic_id'];
    if (!topicId) {
      return;
    }
    app.turnToPage('communityDetail', {
      detail: topicId,
      franchisee: franchisee || app.getPageFranchiseeId() || '',
    });
  },
  /**
   * 详情：资讯详情
   */
  'news': ({customFeature, franchisee}) => {
    let newsId = customFeature['news-id'] || customFeature['news_id'];
    if (!newsId) {
      return;
    }
    console.log('newsId', newsId)
    app.turnToPage('newsDetail', {
      detail: newsId,
      franchisee: franchisee || app.getPageFranchiseeId() || '',
    });
  },
  /**
   * 功能：分享朋友圈
   */
  'page-share': ({customFeature, franchisee}) => {
    let pageInstance = app.getAppCurrentPage();
    let queryStr = '';
    for (let i in pageInstance.sharePageParams) {
      queryStr += '&' + i + '=' + pageInstance.sharePageParams[i]
    }
    let router = pageInstance.state.router;
    // TODO: options.detail 未处理
    let objId = router == 'newsDetail' ? pageInstance.options.detail : router;
    let shareType = router == 'newsDetail' ? 17 : 11;

    app.sendRequest({
      url: '/index.php?r=AppDistribution/DistributionShareQRCode',
      data: {
        obj_id: objId,
        type: shareType,
        text: customFeature.pageShareCustomText,
        goods_img: customFeature.pageShareImgUrl,
        params: queryStr,
        p_id: app.globalData.p_id
      },
      success: function (res) {
        appInstance.pageQrcodeRef.current.show({
          pageQRCodeData: {
            'shareDialogShow': 0,
            'shareMenuShow': true,
            'goodsInfo': res.data
          }
        });
      }
    })
  },
  /**
   * 功能：分享朋友圈
   */
  'share': ({customFeature}) => {
    app.shareClickEvent();
  },
  /**
   * 详情：微信优惠券详情
   */
  'wx-coupon': ({customFeature}) => {
    Toast.info('当前不支持微信优惠券');
    return;
    let wxcouponId = customFeature['wxcoupon-id'] || customFeature['wxcoupon_id'];
    app.sendRequest({
      url: '/index.php?r=appWeChatCoupon/getSignature',
      data: {
        card_id: wxcouponId
      },
      success: function (res) {
        // TODO: 微信优惠券
        // wx.addCard({
        //   cardList: [
        //     {
        //       cardId: wxcouponId,
        //       cardExt: '{"nonce_str":"' + res.data.timestamp + '","timestamp":"' + res.data.timestamp + '", "signature":"' + res.data.signature + '"}'
        //     }
        //   ],
        //   success: function (res) {
        //     app.sendRequest({
        //       url: '/index.php?r=appWeChatCoupon/recvCoupon',
        //       data: {
        //         code: res.cardList[0].code,
        //         card_id: res.cardList[0].cardId
        //       },
        //       success: function (res) {
        //         app.showModal({
        //           content: '领取卡券成功'
        //         })
        //       }
        //     });
        //   }
        // })
      }
    });
  },
  /**
   * 营销: 会员卡
   */
  'vip-card-list': ({franchisee}) => {
    app.turnToPage('vipCard', {
      franchisee: franchisee || app.getPageFranchiseeId() || '',
    });
  },
  /**
   * 功能：足迹
   */
  'goods-foot-print': () => {
    app.turnToPage('goodsFootPrint');
  },
  /**
   * 功能：收藏
   */
  'goods-favorites': () => {
    app.turnToPage('goodsFavorites');
  },
  /**
   * 营销：会员权益
   */
  'vip-interests': ({franchisee}) => {
    franchisee = franchisee || app.getPageFranchiseeId() || '';
    let queryStr = franchisee ? '?franchisee=' + franchisee : '';
    app.turnToPage('vipBenefits', {
      franchisee: franchisee || app.getPageFranchiseeId() || '',
    });
  },
  /**
   * 功能：扫码购
   */
  'goods-scan-code': () => {
    let path = 'shoppingCart?goodsScanCode=true';
    app.getAppECStoreConfig((res) => {
      if (res.cart_config.shopping_by_scanning_code == 1) {
        app.turnToPage(path);
      } else {
        app.showModal({
          content: '暂未开通扫码购'
        })
      }
    })
  },
  /**
   * 功能：预览大图
   */
  'preview-picture': ({event}) => {
    let dataset = event.currentTarget.dataset;
    // TODO 待处理 dataset不能存非字符串类型
    let urls = dataset.imgarr instanceof Array ? dataset.imgarr : [dataset.imgarr];
    if (!dataset.imgarr && !dataset.img){
      return;
    }
    app.previewImage({
      current: dataset.img || urls[0],
      urls: urls,
    });
  },
  /**
   * 功能：弹窗控制
   */
  'popup-window-control': ({customFeature}) => {
    let windowControl = customFeature.windowControl;
    let componentIndex = null;
    // 找出要控制的弹窗组件
    let component = pageInstance.state.eles.find((ele, index) => {
      // 受控弹窗组件id存在customFeature中
      if (ele.customFeature.id === windowControl.popupWindowId) {
        componentIndex = index;
        return true;
      }
    });
    if (!component) {
      return;
    }
    if (windowControl.action === 'show') {
      component['showPopupWindow'] = true;
    } else if (windowControl.action === 'hide') {
      component['showPopupWindow'] = false;
    }
    // 设置页面组件数据
    pageMethod.setCustomComponentData(componentIndex, component);
    // 自动关闭
    if (component.customFeature.autoClose) {
      setTimeout(() => {
        component['showPopupWindow'] = false;
        pageMethod.setCustomComponentData(componentIndex, component);
      }, +component.customFeature.closeDelay * 1000);
    }
  },
  /**
   * 功能：侧边栏控制
   */
  'sidebar-control': ({customFeature}) => {
    let sidebarControl = customFeature.sidebarControl;
    let componentIndex = null;
    // 找出要控制的侧边栏
    let component = pageInstance.state.eles.find((ele, index) => {
      // 受控侧边栏组件id存在customFeature中
      if (ele.customFeature.id === sidebarControl.sidebarId) {
        componentIndex = index;
        return true;
      }
    });
    if (!component) {
      return;
    }
    if (sidebarControl.action === 'show') {
      component['showSidebar'] = true;
    } else if (sidebarControl.action === 'hide') {
      component['hideSidebar'] = true;
    }
    // 设置页面组件数据
    pageMethod.setCustomComponentData(componentIndex, component);
  },
  /**
   * 功能：刷新列表
   */
  'refresh-list': ({customFeature}) => {
    app.tapRefreshListHandler(null, {
      refresh_object: customFeature.refresh_object,
      index_segment: customFeature.index_segment,
      index_value: customFeature.index_value
    });
  },
  /**
   * 功能：搜索
   */
  'search': ({customFeature}) => {
    let pageInstance = app.getAppCurrentPage();
    let listId = customFeature.search.listId;
    let data = pageInstance.data.eles;
    let searchCompindex = -1;
    for (let i = 0; i < data.length; i++) {
      if (data[i].customFeature && listId == data[i].customFeature.id) {
        searchCompindex = i;
        break;
      }
    }
    if (searchCompindex > -1) {
      let searchCompData = pageInstance.data.eles[searchCompindex];
      if (searchCompData.type == 'goods-list') {
        app.turnToPage('classifyGoodsListPage', {
          form: searchCompData.customFeature.form
        })
      } else {
        app.showModal({
          content: '搜索的点击事件只能关联电商、到店、预约列表'
        })
        return;
      }
    } else {
      app.showModal({
        content: '找不到搜索关联的列表'
      })
    }
  },
  /**
   * 功能：回到顶部
   */
  'top': () => {
    app.pageScrollTo(0);
  },
  /**
   * 通知推送：点击事件
   */
  'click-event': ({customFeature}) => {
    let lookLink = customFeature['look-link'];
    app.turnToPage(lookLink, {
      franchisee: franchisee || app.getPageFranchiseeId() || '',
    });
  },
  /**
   * 详情：会员卡详情
   */
  'wx-vip-card': ({customFeature}) => {
    Toast.info('暂不支持微信会员卡');
    return;
    // let cardId = customFeature['card-id'] ||  customFeature['card_id'];
    // let id = customFeature['wx-vip-card-id'] || customFeature['wx_vip_card_id'];
    // if (cardId){
    //   app.sendRequest({
    //     url: '/index.php?r=appWeChatCoupon/getSignature',
    //     data: {
    //       card_id: cardId
    //     },
    //     success: function (res) {
    //       wx.addCard({
    //         cardList: [
    //           {
    //             cardId: cardId,
    //             cardExt: '{"nonce_str":"' + res.data.timestamp + '","timestamp":"' + res.data.timestamp + '", "signature":"' + res.data.signature + '"}'
    //           }
    //         ],
    //         success: function (res) {
    //           console.log(res);
    //           app.showModal({
    //             content: '领取成功'
    //           });
    //         }
    //       })
    //     }
    //   });
    // } 
  },
  /**
   * 微分商城
   */
  'differential-mall': () => {
    app.turnToPage('dMWebView', {
      franchisee: franchisee || app.getPageFranchiseeId() || '',
    });
  },
  /**
   * 商品分类（仅多商家）(传值略有不同)
   */
  'goods-classify': ({customFeature}) => {
    let type = 'goods';
    if (form.goods_type == 0) {
      type = 'goods';
    } else if (form.goods_type == 3) {
      type = 'tostore';
    } else if (form.goods_type == 1) {
      type = 'appointment';
    }
    franchiseeId = franchiseeId || app.getPageFranchiseeId();
    app.turnToPage('goodsMore', {
      detail: type,
      categroy: customFeature.id,
      categroyName: customFeature.name,
      franchisee: franchisee || app.getPageFranchiseeId() || '',
    });
  },
  'turnToH5': ({ customFeature}) => {
    window.location.href = customFeature.turn_to_h5_url;
    return;
  }
};
/**
 * 点击事件触发函数
 * @param {object} options
 * @param {object} options.customFeature 必填 点击事件含有的参数
 * @param {object} [options.franchisee] 是否为多商家，是则为多商家appid
 * @param {object} [options.event] 事件
 */
function customEvent(options = {}) {
  const { customFeature } = options;
  if (!customFeature['action']) {
    return;
  }
  if (!handler[customFeature['action']]) {
    // Toast.info('当前点击事件尚未开发');
    return;
  }
  handler[customFeature['action']](options);
}

/**
 * 兼容旧点击事件调用
 * @param {*} action 
 */
/**
 * 兼容旧点击事件调用
 * @description 返回旧版对象（建议后续不要这样调用）
 * 改为customEvent()
 */
const clickEventHandler = (() => {
  let obj = {};
  for (let key in handler) {
    obj[key] = (param, franchisee, event) => {
      handler[key]({
       customFeature: param,
       franchisee: franchisee,
       event: event
      })
   }
  }
  return obj;
})()

export {
  customEvent,
  clickEventHandler
}


// WEBPACK FOOTER //
// ./src/utils/customEvent.jsx